/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse,
  MarqCommonProtocolFileResponse,
  MonitoringFilterProtocolResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsCancelConfirmRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsExportCsvRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetChannelGroupCountResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetDetailRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetStatusCountResponse,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetWebsiteFilterRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequest,
  MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostDismissRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class SocialMediaPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyChannelGroupCountList
   * @request GET:/social/media/piracy/channel_group_count
   */
  mediaPiracyChannelGroupCountList = (params: RequestParams = {}) =>
    this.http.request<MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetChannelGroupCountResponse, any>({
      path: `/social/media/piracy/channel_group_count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyFilterPlatformList
   * @request GET:/social/media/piracy/filter/platform
   */
  mediaPiracyFilterPlatformList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/social/media/piracy/filter/platform`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyStatusCountList
   * @request GET:/social/media/piracy/status_count
   */
  mediaPiracyStatusCountList = (params: RequestParams = {}) =>
    this.http.request<MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetStatusCountResponse, any>({
      path: `/social/media/piracy/status_count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyListingCountCreate
   * @request POST:/social/media/piracy/listing_count
   */
  mediaPiracyListingCountCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingCountResponse, any>({
      path: `/social/media/piracy/listing_count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyFilterWebsiteCreate
   * @request POST:/social/media/piracy/filter/website
   */
  mediaPiracyFilterWebsiteCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetWebsiteFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/social/media/piracy/filter/website`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyFilterAssetList
   * @request GET:/social/media/piracy/filter/asset
   */
  mediaPiracyFilterAssetList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/social/media/piracy/filter/asset`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyExportCsvCreate
   * @request POST:/social/media/piracy/export_csv
   */
  mediaPiracyExportCsvCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsExportCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/social/media/piracy/export_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyListCreate
   * @request POST:/social/media/piracy/list
   */
  mediaPiracyListCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListResponse, any>({
      path: `/social/media/piracy/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyListingIdListCreate
   * @request POST:/social/media/piracy/listing-id-list
   */
  mediaPiracyListingIdListCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetListingIdListResponse, any>({
      path: `/social/media/piracy/listing-id-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyDetailCreate
   * @request POST:/social/media/piracy/detail
   */
  mediaPiracyDetailCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsGetDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse, any>({
      path: `/social/media/piracy/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyConfirmCreate
   * @request POST:/social/media/piracy/confirm
   */
  mediaPiracyConfirmCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/social/media/piracy/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyDismissCreate
   * @request POST:/social/media/piracy/dismiss
   */
  mediaPiracyDismissCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsPostDismissRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/social/media/piracy/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SocialMediaPiracy
   * @name MediaPiracyCancelConfirmCreate
   * @request POST:/social/media/piracy/cancel-confirm
   */
  mediaPiracyCancelConfirmCreate = (
    data: MonitoringSocialmediaPiracySocialMediaPiracyProtocolsCancelConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/social/media/piracy/cancel-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
